// Bridges live LiveKit camera tracks (identified by LiveKit "identity" = user id) to any
// component that wants to paint that participant's live video onto something else (e.g. a
// Konva token sprite on the map). Module-level so it survives across route/panel remounts.

const elements = new Map(); // identity -> HTMLVideoElement
const listeners = new Map(); // identity -> Set<callback>

export function registerVideoElement(identity, videoEl) {
  elements.set(identity, videoEl);
  (listeners.get(identity) || new Set()).forEach((cb) => cb(videoEl));
}

export function unregisterVideoElement(identity) {
  elements.delete(identity);
  (listeners.get(identity) || new Set()).forEach((cb) => cb(null));
}

export function getVideoElement(identity) {
  return elements.get(identity) || null;
}

export function subscribeVideoElement(identity, cb) {
  if (!identity) return () => {};
  if (!listeners.has(identity)) listeners.set(identity, new Set());
  listeners.get(identity).add(cb);
  cb(elements.get(identity) || null);
  return () => listeners.get(identity)?.delete(cb);
}
